import React from "react";

class AuthBanner extends React.Component {
  render() {
    return (
      <section className="header_section-my">
        <div className="bg-overlay" />
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-white text-center">
                <h2 className="font-weight-bold">{this.props.title}</h2>
                <div className="home_divider mt-3 mb-3 mx-auto" />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default AuthBanner;



// WEBPACK FOOTER //
// ./src/reusable/AuthBanner.js